@if (!isLoading) {
  <div class="main-container" data-cy="patient-portal-plans-main-container">
    <div class="page-header" data-cy="patient-portal-plans-header">
      Payment Plans
    </div>
    <mat-divider data-cy="patient-portal-plans-divider"></mat-divider>
    @if (paymentPlans.length === 0) {
      <div class="no-invoices-message" data-cy="patient-portal-plans-no-plans-message">
        You currently have no payment plans
      </div>
    }
    @if (paymentPlans.length > 0) {
      <div class="payments-container" data-cy="patient-portal-plans-list-container">
        @for (paymentPlan of paymentPlans; track paymentPlan; let i = $index) {
          <div class="payment-item" data-cy="patient-portal-plans-plan-item" [class.offset]="i % 2">
            <div class="item-detail" data-cy="patient-portal-plans-plan-description-label">
              {{ paymentPlan.Description }}
            </div>
            <div class="item-detail"
              [class.paid-detail]="paymentPlan.isPatientAccepted"
              [class.unpaid-detail]="!paymentPlan.isPatientAccepted"
              data-cy="patient-portal-plans-plan-status-label">
              {{ paymentPlan.DATA_IS_PAID ? 'Paid' : (paymentPlan.isPatientAccepted ? 'Approved - Outstanding' : 'Awaiting Approval') }}
            </div>
            <div class="item-detail">
              <button mat-button color="primary" (click)="openReportForSelectedOption(paymentPlan)" data-cy="patient-portal-plans-open-plan-button">Open</button>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-plans-loading-spinner-container">
    <mat-spinner data-cy="patient-portal-plans-loading-spinner"></mat-spinner>
  </div>
}
